"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case "GET_CHART_DATA_LIST": {
            const { title, label, dataList, category } = payload;
            dataList.sort((a, b) => a.year - b.year);
            if (!state.chartLabels.some((chartLabel) => chartLabel === label)) {
                return Object.assign(Object.assign({}, state), { chartTitle: title, chartLabels: [...state.chartLabels, label], chartDataList: dataList, chartCategory: category });
            }
            else {
                return Object.assign({}, state);
            }
        }
        case "SET_CHART_DATA_LIST": {
            const { title, label, dataValue, category } = payload;
            console.log(dataValue);
            return Object.assign(Object.assign({}, state), { chartTitle: title, chartLabels: [...state.chartLabels, label], chartDataList: [...state.chartDataList, dataValue], chartCategory: category });
        }
        case "REMOVE_CHART_DATA_LIST": {
            return Object.assign(Object.assign({}, state), { chartTitle: payload.chartTitle, chartLabels: payload.chartLabels, chartDataList: payload.chartDataList, chartCategory: payload.chartCategory });
        }
        case "REMOVE_CHART_DATA_ELEMENT_BY_LABEL": {
            const index = state.chartLabels.indexOf(payload);
            let updatedLabels = JSON.parse(JSON.stringify(state.chartLabels));
            let chartDataListCopy = JSON.parse(JSON.stringify(state.chartDataList));
            for (const element of chartDataListCopy) {
                let updatedData = JSON.parse(JSON.stringify(element.data));
                if (index > -1) {
                    updatedData.splice(index, 1);
                    element.data = updatedData;
                }
            }
            if (index > -1) {
                updatedLabels.splice(index, 1);
            }
            return Object.assign(Object.assign({}, state), { chartLabels: updatedLabels, chartDataList: chartDataListCopy });
        }
        default:
            return state;
    }
};
